module.exports = __webpack_public_path__ + "static/whitepaper-59f77ec41fd42a5bb7b86e4b6b0e33ce.png";